// Local translations
export const T = {
  en_GB: {
    showLineChart: "Show Chart",
    showLineChartDesc: "Display the line chart visualization",
    showSummaryTable: "Show Summary Table",
    showSummaryTableDesc: "Yearly summary with deposits, returns, and value",
    showYearlyTable: "Show Yearly Table",
    showYearlyTableDesc: "Monthly breakdown for each year",
    compareWithBank: "Compare with bank savings",
    compareWithBankDesc:
      "Show a line for the same cash flows at the collection's flat bank rate (rate set in the portfolio collection's calculation settings)",
    atLeastOneDisplayOption: "At least one display option must be selected",
  },
  nb_NO: {
    showLineChart: "Vis diagram",
    showLineChartDesc: "Vis linjediagramvisualisering",
    showSummaryTable: "Vis sammendragstabell",
    showSummaryTableDesc: "Årlig sammendrag med innskudd, avkastning og verdi",
    showYearlyTable: "Vis årstabell",
    showYearlyTableDesc: "Månedlig fordeling for hvert år",
    compareWithBank: "Sammenlign med banksparing",
    compareWithBankDesc:
      "Vis en linje for de samme kontantstrømmene med samlingens flate bankrente (renten settes i porteføljesamlingens beregningsinnstillinger)",
    atLeastOneDisplayOption: "Minst ett visningsalternativ må være valgt",
  },
} as const;
